import styled from 'styled-components';
import Copywrite from '@assets/images/content/stages/copywrite.svg'; 
import Compliance from '@assets/images/content/stages/compliance.svg'; 
import Proofreaders from '@assets/images/content/stages/proofreaders.svg'; 
import Release from '@assets/images/content/stages/release.svg'; 
import Seo from '@assets/images/content/stages/seo.svg'; 
import Technical from '@assets/images/content/stages/technical.svg'; 

export const CopywriteImg = styled(Copywrite)`
`;

export const ComplianceImg = styled(Compliance)`
`;

export const ProofreadersImg = styled(Proofreaders)`
`;

export const ReleaseImg = styled(Release)`
`;

export const SeoImg = styled(Seo)`
`;

export const TechnicalImg = styled(Technical)`
`;
